import styled from 'styled-components';
import { Button } from '../../../components/utils/Button/Button';
import { Text14Light, Text22Bold, Text32ExtraBold } from '../../../components/utils/Text/Text.styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 4.2rem;

  @media only screen and (max-width: 500px) {
    height: 100%;
    padding: 4.2rem 1.6rem 5rem 1.6rem;
  }
`;

export const Form = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  width: 42rem;
  margin-bottom: 10rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
    margin-bottom: 2rem;
  }
`;

export const StyledButton = styled(Button)`
  width: 24rem;

  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    margin-top: auto;
  }
`;

export const Title = styled(Text32ExtraBold)`
  margin-bottom: 4.8rem;
  text-align: center;

  @media only screen and (max-width: 500px) {
    margin-top: 3rem;
  }
`;

export const AgreementContainer = styled.div`
  width: 66rem;
  flex-direction: column;
  display: flex;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  gap: 2.4rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const AcceptAgreement = styled.div`
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media only screen and (max-width: 500px) {
    margin-bottom: unset;
  }
`;

export const AgreementContent = styled.div``;

export const AgreementTitleText = styled(Text22Bold)`
  margin-bottom: 1rem;
`;

export const AgreementText = styled(Text14Light)`
  line-height: 2.2rem;
  opacity: 0.5;
  text-align: justify;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  gap: 1.2rem;
`;

export const CheckboxWrapper = styled.div`
  cursor: pointer;
`;

export const CheckboxText = styled(Text14Light)`
  line-height: 2.1rem;
  letter-spacing: -0.42px;

  span {
    text-decoration-line: underline;
    font-weight: 600;
    color: #1672ba;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const BackIconWrapper = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 1.2rem;
`;

export const FormHeader = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  margin-bottom: 14rem;
`;
